function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h640v480H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e8112d",
  d: "M256 0h128v480H256z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#e8112d",
  d: "M0 176h640v128H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "gg_svg__a",
  fill: "#f9dd16",
  d: "M110 286.7l23.3-23.4h210v-46.6h-210L110 193.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  width: 36,
  height: 24,
  transform: "rotate(90 320 240)",
  xlinkHref: "#gg_svg__a"
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  width: 36,
  height: 24,
  transform: "rotate(-90 320 240)",
  xlinkHref: "#gg_svg__a"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  width: 36,
  height: 24,
  transform: "rotate(180 320 240)",
  xlinkHref: "#gg_svg__a"
});

var SvgGg = function SvgGg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default SvgGg;